import { render, staticRenderFns } from "./TimelineTabSidebar.vue?vue&type=template&id=4ff0860e"
import script from "./TimelineTabSidebar.vue?vue&type=script&lang=js"
export * from "./TimelineTabSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports